function getTime(timestamp) {
	// Convert Firestore timestamp to JavaScript Date object
	const dateObject = timestamp?.toDate();

	// Get hour and minute
	const hours = dateObject?.getHours();
	const minutes = dateObject?.getMinutes();

	// Format the result in 24-hour format
	const formattedTime = `${hours < 10 ? "0" : ""}${hours}:${
		minutes < 10 ? "0" : ""
	}${minutes}`;

	return formattedTime;
}

function getDate(timestamp, format = "YYYY-MM-DD", withDate = false) {
	// Convert Firebase Firestore timestamp to JavaScript Date object
	const dateObject = timestamp?.toDate();

	if (!dateObject) return "";

	// Extract date components
	const year = dateObject?.getFullYear();
	const month = dateObject?.getMonth();
	const day = dateObject?.getDate();

	// Month names array
	const monthNames = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];

	if (format === "MMMM YYYY") {
		if (withDate) {
			return `${day} ${monthNames[month]} ${year}`;
		}

		return `${monthNames[month]} ${year}`;
	}

	// Format the result
	const formattedDate = `${year}-${month < 10 ? "0" : ""}${month}-${
		day < 10 ? "0" : ""
	}${day}`;

	return formattedDate;
}

const getCurrentHour = () => {
	const date = new Date();
	return date.getHours();
};

export { getTime, getDate, getCurrentHour };
